module.exports = __webpack_public_path__ + "img/course_bg01@3x.f55a75e4.png";